var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { minimized: _vm.minimized },
      attrs: { id: "import-status-card" },
    },
    [
      !_vm.minimized
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("BucketSpinner", { attrs: { "class-name": "spinner" } }),
              _vm._v(" "),
              _c("div", { staticClass: "items" }, [
                _c("div", { staticClass: "item" }, [
                  _c("i", { staticClass: "material-icons text-success" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.state.imported) +
                      " Tamamlandı\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item" }, [
                  _c("i", { staticClass: "material-icons text-danger" }, [
                    _vm._v("cancel"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.state.failed) +
                      " Başarısız\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item" }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons text-info",
                      class: { spin: _vm.state.status === "processing" },
                    },
                    [_vm._v("loop")]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.state.percent) +
                      "% Tamamlandı\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "close-btn", on: { click: _vm.minimize } },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "minimized-content", on: { click: _vm.maximize } },
            [
              _c("i", { staticClass: "material-icons spin" }, [
                _vm._v("autorenew"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "minimized-text" }, [
                _vm._v(_vm._s(_vm.state.percent) + "%"),
              ]),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }